import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Vote = ({ type = 0, total = 0, majority = 0, dem = 0, gop = 0, winner = null, noteLeft = '', noteRight = '' }) => {
    const demPct = total ? (dem / total) * 100 : 0;
    const gopPct = total ? (gop / total) * 100 : 0;
    const markerPct = total ? (majority / total) * 100 : 0;

    return (
        <section className={styles.card}>
            <div className={styles.body}>
                <div className={styles.scores}>
                    <div className={styles.side}>
                        <div className={`${styles.count} ${styles.dem}`}>{dem}</div>
                        <div className={`${styles.name} ${styles.dem}`}>民主党</div>
                    </div>
                    <div className={`${styles.side} ${styles.sideRight}`}>
                        <div className={`${styles.count} ${styles.gop}`}>{gop}</div>
                        <div className={`${styles.name} ${styles.gop}`}>共和党</div>
                    </div>
                </div>
                <div className={styles.track}>
                    <div className={styles.pendingBar} />
                    <div
                        className={`${styles.demBar}`}
                        style={{
                            width: `${demPct}%`,
                        }}
                    />
                    <div
                        className={`${styles.gopBar}`}
                        style={{
                            width: `${gopPct}%`
                        }}
                    />
                    <img className={styles.demLogo} src="https://x0.ifengimg.com/ucms/2026_43/A58BE0E8A605FC3DB17928EBC47DDDDDA168C502_size2_w72_h72.png" alt="" />
                    <img className={styles.gopLogo} src="https://x0.ifengimg.com/ucms/2026_43/2052A7637992123EED68714287BB250A8F2DB93A_size2_w72_h72.png" alt="" />
                </div>
                <div className={styles.marker} style={{ left: `${markerPct}%` }}>
                    <div className={styles.markerText}>{type === 0 ? `${majority}获胜` : majority}</div>
                    <div className={styles.markerArrow} />
                    <div className={styles.markerLine} />
                </div>
            </div>
            {winner === 'dem' ? <img className={`${styles.stamp} ${styles.stampDem}`} src="https://x0.ifengimg.com/ucms/2026_43/D4DFAB61472D10FCA0F15A6D6E21DA8FB7538B5B_size22_w160_h160.png" alt="民主党胜选" /> : null}
            {winner === 'gop' ? <img className={`${styles.stamp} ${styles.stampGop}`} src="https://x0.ifengimg.com/ucms/2026_43/C15ED72E2806DD74044E543B072B5318454D4E10_size22_w160_h160.png" alt="共和党胜选" /> : null}
            {noteLeft || noteRight ? (
                <div className={styles.notes}>
                    <div className={styles.noteLeft}>{noteLeft}</div>
                    <div className={styles.noteRight}>{noteRight}</div>
                </div>
            ) : null}
        </section>
    );
};

Vote.propTypes = {
    type: PropTypes.number,
    total: PropTypes.number,
    majority: PropTypes.number,
    dem: PropTypes.number,
    gop: PropTypes.number,
    winner: PropTypes.oneOf(['dem', 'gop']),
    noteLeft: PropTypes.string,
    noteRight: PropTypes.string,
};

export default errorBoundary(Vote);
